var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 2.40001C1.6001 2.18783 1.68438 1.98435 1.83441 1.83432C1.98444 1.68429 2.18792 1.60001 2.4001 1.60001H4.1225C4.31186 1.60009 4.49506 1.66735 4.63949 1.78981C4.78393 1.91228 4.88024 2.08201 4.9113 2.26881L5.5033 5.81681C5.53158 5.98578 5.50488 6.15937 5.42711 6.31203C5.34934 6.46469 5.22462 6.58835 5.0713 6.66481L3.8329 7.28321C4.27698 8.38373 4.93836 9.38343 5.77752 10.2226C6.61667 11.0617 7.61638 11.7231 8.7169 12.1672L9.3361 10.9288C9.41252 10.7756 9.53605 10.651 9.68854 10.5733C9.84103 10.4955 10.0144 10.4687 10.1833 10.4968L13.7313 11.0888C13.9181 11.1199 14.0878 11.2162 14.2103 11.3606C14.3328 11.505 14.4 11.6882 14.4001 11.8776V13.6C14.4001 13.8122 14.3158 14.0157 14.1658 14.1657C14.0158 14.3157 13.8123 14.4 13.6001 14.4H12.0001C6.2561 14.4 1.6001 9.74401 1.6001 4.00001V2.40001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.5ef5925bb06cb097d384716216464d00.svg";
export { ForwardRef as ReactComponent };